import React, { Component } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import history from './history';
import './App.css';
import HomePage from './Containers/HomePage';
import ScrollToTop from './Components/ScrollToTop';
import Header from './Components/Header';
import VerificationPage from './Containers/VerificationPage';
import CertificatePrintPage from './Containers/CertificatePrintPage';
import CertificatePaymentPage from './Containers/CertificatePaymentPage';
import PaymentResponsePage from './Containers/PaymentResponsePage';
import CertificateStatusPage from './Containers/CertificateStatusPage';
import IdCardRequestPage from './Containers/IdCardRequestPage';
import IdCardPaymentPage from './Containers/IdCardPaymentPage';
import IdCardPaymentResponsePage from './Containers/IdCardPaymentResponsePage';
import AdmissionPrintRequestPage from './Containers/AdmissionPrintRequestPage';
import AdmissionPrintPaymentPage from './Containers/AdmissionPrintPaymentPage';
import AdmissionPrintResponsePage from './Containers/AdmissionPrintResponsePage';

class App extends Component {
  render() {
    return (
      <Router history={history} onUpdate={() => window.scrollTo(0, 0)} >
        <ScrollToTop>
          <div>
            <Header />
            <Switch>
              <Route name="home" exact path="/" component={HomePage} />
              <Route name="home" exact path="/certificate-verfication" render={(props) => <VerificationPage {...props} />} />
              <Route name="home" exact path="/certificate-print" render={(props) => <CertificatePrintPage {...props} />} />
              <Route name="home" exact path="/certificate-fees-payment" render={(props) => <CertificatePaymentPage {...props} />} />
              <Route name="home" exact path="/payment/response" render={(props) => <PaymentResponsePage {...props} />} />
              <Route name="home" exact path="/certificate-status" render={(props) => <CertificateStatusPage {...props} />} />
              <Route name="home" exact path="/idcard-request" render={(props) => <IdCardRequestPage {...props} />} />
              <Route name="home" exact path="/idcard-fees-payment" render={(props) => <IdCardPaymentPage {...props} />} />
              <Route name="home" exact path="/idcard-payment/response" render={(props) => <IdCardPaymentResponsePage {...props} />} />
              <Route name="home" exact path="/admission-print-request" render={(props) => <AdmissionPrintRequestPage {...props} />} />
              <Route name="home" exact path="/admission-print-payment" render={(props) => <AdmissionPrintPaymentPage {...props} />} />
              <Route name="home" exact path="/admission-print/response" render={(props) => <AdmissionPrintResponsePage {...props} />} />
            </Switch>
          </div>
        </ScrollToTop>
      </Router>
    );
  }
}

export default App;
